import { ENVIO_CLIENTES_FINALES } from '../constants/filters';

export const filterEnvioClientesFinales = ({ filtersEnvioClientesFinales }) => {
    return {
        type: ENVIO_CLIENTES_FINALES,
        filtersEnvioClientesFinales,
    };
};
